module.exports = __webpack_public_path__ + "img/img_gcs_retail@3x.cfa86897.png";